/**
 * Copyright (c) 2022-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

export const BETA_SUBJECT = "betaSubject";
export const SUBJECT = "subject";
export const RESOURCE_COLLECTION = "resourceCollection";
export const ARCHIVE_SUBJECT = "archiveSubject";

export const subjectTypes = {
  BETA_SUBJECT,
  SUBJECT,
  RESOURCE_COLLECTION,
  ARCHIVE_SUBJECT,
} as const;

export type SubjectType = (typeof subjectTypes)[keyof typeof subjectTypes];
